@use 'src/global/variables.scss' as var;

c-feedback {
  display: flex;
  z-index: 9999;
  flex-direction: row;
  background-color: dimgrey;
  border-radius: 8px;
  position: absolute;
  right: -20px;
  bottom: -20px;
  padding: 5px;

  .feedback-container {
    text-align: center;
    right: 0;
    background-color: dimgrey;
    border-radius: 8px;

    textarea {
      font-family: Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
      padding: 3px;
      border-radius: 8px;
      width: 150px;
      min-height: 50px;

      &:focus,
      &:hover {
        outline: 2px solid var.$focus-color;
        outline-offset: 2px;
      }
    }

    .submit-button {
      margin-top: var.$margin;
      margin-bottom: var.$margin;
      justify-self: center;
      width: fit-content;
      border-radius: 8px;
      padding: 5px;
      color: white;
      background-color: #020e25;
    }
  }

  button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    outline: none;
    width: calc(#{var.$conversation-avatar-size} / 2 - #{var.$margin} / 2);
    height: calc(#{var.$conversation-avatar-size} / 2 - #{var.$margin} / 2);

    #outline {
      fill: var.$primary-color;
    }

    &.thumbs-up,
    &.thumbs-down {
      display: unset;
      margin-top: 3px;
      fill: #f7f7f7;
    }

    &.thumbs-up {
      margin-right: var.$margin;
      &.selected {
        fill: var.$color-green;
      }
      &:focus,
      &:hover {
        outline: 2px solid var.$focus-color;
        outline-offset: 2px;
      }
    }

    &.thumbs-down {
      transform: rotate(180deg);
      &.selected {
        fill: var.$secondary-color;
      }
      &:focus,
      &:hover {
        outline: 2px solid var.$focus-color;
        outline-offset: 2px;
      }
    }

    svg {
      width: 100%;
      height: 100%;
      max-width: 24px;
      max-height: 24px;
    }
  }
}
